import { Instagram, Twitter, Youtube, Facebook, Sparkles, Users, Upload, ShoppingBag, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { FOOTER_QUICK } from "../lib/constants";
import { useBranding } from "../lib/branding";
import { useMediaPlayer } from "../lib/player";

const iconMap = { Sparkles, Users, Upload, ShoppingBag };

export default function Footer() {
    const { logoUrl } = useBranding();
    const { current } = useMediaPlayer();
    // MiniPlayer floats over the bottom of the page when a track is loaded.
    // Add extra bottom padding so the MyStreetz mark + copyright aren't covered.
    const playerActive = !!current;
    return (
        <footer
            data-testid="site-footer"
            className={`bg-black border-t border-streetz-line mt-20 ${playerActive ? "pb-32 md:pb-28" : ""}`}
        >
            <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 border-b border-streetz-line">
                {FOOTER_QUICK.map((card) => {
                    const Icon = iconMap[card.icon];
                    return (
                        <Link
                            key={card.key}
                            to={card.to}
                            data-testid={`footer-quick-${card.key}`}
                            className="group block"
                        >
                            <div className="flex items-center gap-3 mb-2">
                                <Icon className="w-5 h-5 text-streetz-yellow" />
                                <span className="overline text-streetz-yellow">
                                    {card.title}
                                </span>
                            </div>
                            <p className="text-sm text-streetz-muted leading-relaxed mb-3 max-w-xs">
                                {card.desc}
                            </p>
                            <span className="inline-flex items-center gap-1 overline text-white group-hover:text-streetz-red transition-colors">
                                {card.cta} <ArrowRight className="w-3 h-3" />
                            </span>
                        </Link>
                    );
                })}
            </div>

            <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-8 flex flex-col md:flex-row items-center justify-between gap-6">
                <div className="flex items-center gap-3 flex-wrap justify-center">
                    <img src={logoUrl} alt="MyStreetz" className="brand-logo h-8 w-auto" />
                    <span className="overline text-streetz-muted">
                        © {new Date().getFullYear()} MyStreetzMag · Sound of the streets
                    </span>
                    <Link to="/terms" data-testid="footer-terms-link" className="overline text-streetz-muted hover:text-streetz-yellow">
                        · TERMS
                    </Link>
                    <Link to="/privacy" data-testid="footer-privacy-link" className="overline text-streetz-muted hover:text-streetz-yellow">
                        · PRIVACY
                    </Link>
                </div>
                <div className="flex items-center gap-4">
                    <span className="overline text-streetz-muted">FOLLOW US</span>
                    {[
                        { Icon: Instagram, label: "instagram" },
                        { Icon: Twitter, label: "twitter" },
                        { Icon: Youtube, label: "youtube" },
                        { Icon: Facebook, label: "facebook" },
                    ].map(({ Icon, label }) => (
                        <a
                            key={label}
                            href={`https://${label}.com`}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={`footer-social-${label}`}
                            aria-label={label}
                            className="h-9 w-9 grid place-items-center border border-streetz-line text-white hover:bg-streetz-red hover:border-streetz-red"
                        >
                            <Icon className="w-4 h-4" />
                        </a>
                    ))}
                </div>
            </div>
        </footer>
    );
}
